"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapSideBarPanel_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBarPanel.vue"));
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
const floating_vue_1 = require("floating-vue");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const SampleProjectAssociation_vue_1 = __importDefault(require("./SampleProjectAssociation.vue"));
let MapSideBarPanelSamplingPoints = class MapSideBarPanelSamplingPoints extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isDownloadLoading = false;
        this.animationTriggeredIndex = -1;
        this.eventTracker = new EventTracker_1.default();
    }
    mounted() {
        this.eventTrackerListener('Open sampling points', true);
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get activeArea() {
        return this.areas[this.tabActive];
    }
    get hasAnySampleAssociated() {
        return !this.samplingPoints.find(point => point.sample_code.length > 0 && point.sample_id > 0);
    }
    showModalSampleAssociation() {
        this.$emit('showModalSampleAssociation');
    }
    download() {
        const extension = 'csv';
        const mimeType = 'text/csv;charset=utf-8;';
        const filename = `${this.activeArea.meta.name} - ${extension}`;
        const columnSeparator = ',';
        const header = [
            (0, trans_1.trans)('tracking.csv.sample_code'),
            (0, trans_1.trans)('tracking.csv.latitude'),
            (0, trans_1.trans)('tracking.csv.longitude'),
            (0, trans_1.trans)('tracking.csv.date'),
            (0, trans_1.trans)('tracking.csv.field_name')
        ].join(columnSeparator);
        const rows = this.activeArea.samplingPoints.reduce((csvRows, point) => {
            const { lat, lon } = this.collectLonPoint(point.geodata);
            csvRows.push([
                point.sample_code || '---',
                lat,
                lon,
                point.collecting_at,
                point.field_name || (0, trans_1.trans)('tracking.csv.no_field_available')
            ].join(columnSeparator));
            return csvRows;
        }, [header]);
        const csvContent = rows.join('\n');
        const blob = new Blob([csvContent], { type: mimeType });
        this.eventTrackerListener('Download sampling points', { "csvRows": rows });
        (0, downloadFile_1.default)(blob, `${filename}.${extension}`, mimeType);
    }
    copyCoord(point, i) {
        const coords = this.collectLonPoint(point);
        const coordsString = coords.lat + ', ' + coords.lon;
        navigator.clipboard.writeText(coordsString);
        this.animationTriggeredIndex = i;
    }
    resetAnimation() {
        this.animationTriggeredIndex = -1;
    }
    collectLonPoint(point) {
        let cadena = point;
        if (cadena.includes('(')) {
            const cadenaTemp = cadena.split('(');
            cadena = cadenaTemp[1];
            if (cadena.includes(')')) {
                const cadenaTemp2 = cadena.split(')');
                cadena = cadenaTemp2[0];
            }
        }
        const values = cadena.split(' ');
        return {
            lat: values[1],
            lon: values[0],
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelSamplingPoints.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelSamplingPoints.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarPanelSamplingPoints.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], MapSideBarPanelSamplingPoints.prototype, "areas", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], MapSideBarPanelSamplingPoints.prototype, "samplingPoints", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], MapSideBarPanelSamplingPoints.prototype, "tabActive", void 0);
MapSideBarPanelSamplingPoints = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            SampleProjectAssociation: SampleProjectAssociation_vue_1.default,
            PinIcon: bmk_ui_framework_2.PinIcon,
            TableBmk: bmk_ui_framework_2.TableBmk,
            TableBody: bmk_ui_framework_2.TableBody,
            TableBodyRow: bmk_ui_framework_2.TableBodyRow,
            TableBodyCell: bmk_ui_framework_2.TableBodyCell,
            DateStylized: bmk_ui_framework_2.DateStylized,
            Dropdown: floating_vue_1.Dropdown,
            Button: bmk_ui_framework_2.Button,
            Copy: lucide_vue_next_1.Copy,
            CodeSnippet: bmk_ui_framework_2.CodeSnippet,
            TableHeader: bmk_ui_framework_2.TableHeader,
            TableHeaderCell: bmk_ui_framework_2.TableHeaderCell,
            MicroFeedback: bmk_ui_framework_2.MicroFeedback,
            Loading: bmk_ui_framework_1.Loading,
            Ribbon: bmk_ui_framework_1.Ribbon
        },
    })
], MapSideBarPanelSamplingPoints);
exports.default = MapSideBarPanelSamplingPoints;
